export default function React_useContext() {
  return (
    <div>
      <h1>React_useContext Component</h1>
      <p>This is the React_useContext tutorial page.</p>
    </div>
  );
}
